let queryString = []

const parser = {
  parse() {
    queryString = location.search.substr(1).split('&').map(item => {
      const pieces = item.split('=')

      return {
        key: pieces[0] || undefined,
        value: pieces[1] || undefined,
      }
    }).filter(item => !!item.key)
  },

  get(key) {
    const index = queryString.findIndex(item => item.key === key)

    if (index === -1) {
      return undefined
    }

    return queryString[index].value
  },

  all() {
    return queryString
  }
}

parser.parse()

export default parser
